import type { LogoutMode } from "@authentication/domain/models/logout.model";
import type { AuthenticationRepository } from "@authentication/domain/repositories/authentication.repository";
import { authenticationTypes } from "@authentication/root/authentication-types.di";
import { inject, injectable } from "inversify";

@injectable()
export class AuthenticationLogoutUseCase {
    constructor(
        @inject(authenticationTypes.repositories.AuthenticationRepository)
        private readonly authenticationRepository: AuthenticationRepository,
    ) {}

    async execute(mode: LogoutMode): Promise<boolean> {
        const result = await this.authenticationRepository.logout(mode);
        return result.isOk();
    }
}
